export default __webpack_public_path__ + "static/media/bg9.49d94ce4.jpg";